/* eslint-disable @typescript-eslint/ban-ts-comment */
import { getObjectValue } from '../../../../../utilities';
import { CalibrationCustomAfterCellChangedParams } from '../../../../ValuationsAllocation/approaches/ExternalValuation/config/customAfterCellsChanged/types';
import {
  ALIAS_LEGEND_MAP,
  EBITDA_CELL_ALIAS_IDENTIFIER,
  PANEL_ID_PREFIX,
  PERFORMANCE_METRICS_OFFSET,
  REVENUE_CELL_ALIAS_IDENTIFIER,
} from '../constants';
import { getCorrespondingFormula } from '../utilities';

const customCalibrationOutputsAfterCellsChanged = (params: CalibrationCustomAfterCellChangedParams) => {
  const { cells, initialChanges, calibration } = getObjectValue(params);

  const calibrationId = calibration.id ?? calibration.panelId.replaceAll('-', '_');
  const panelId = `${PANEL_ID_PREFIX}${calibrationId}.`;

  const getKeysByColumn = (column: string) => (calibration.performances ?? []).map((performance, index) => {
    if (performance.enabled) {
      return `${panelId}${column}${index + PERFORMANCE_METRICS_OFFSET}`;
    }
    return '';
  }).filter(key => key.length !== 0);

  const changes = [...initialChanges];

  const revenueCells = [
    cells.ltm_revenue_multiple_premium_over_median,
    cells.ntm_revenue_multiple_premium_over_median,
  ];
  const ebitdaCells = [
    cells.ltm_ebitda_multiple_premium_over_median,
    cells.ntm_ebitda_multiple_premium_over_median,
  ];
  changes.forEach(change => {
    const { cell, value } = change;
    const { alias } = cell;
    let formula = '';
    if (alias.includes(REVENUE_CELL_ALIAS_IDENTIFIER)) {
      revenueCells.forEach(revenue => {
        const newAlias = revenue.alias.substring(0, 3);
        const columnLegend = ALIAS_LEGEND_MAP[revenue.alias];
        const keys = getKeysByColumn(columnLegend);
        formula = getCorrespondingFormula(value, newAlias, REVENUE_CELL_ALIAS_IDENTIFIER, keys);
        changes.push({ cell: revenue, value: formula });
      });
    } else if (alias.includes(EBITDA_CELL_ALIAS_IDENTIFIER)) {
      ebitdaCells.forEach(ebitda => {
        const newAlias = ebitda.alias.substring(0, 3);
        const columnLegend = ALIAS_LEGEND_MAP[ebitda.alias];
        const keys = getKeysByColumn(columnLegend);
        formula = getCorrespondingFormula(value, newAlias, EBITDA_CELL_ALIAS_IDENTIFIER, keys);
        changes.push({ cell: ebitda, value: formula });
      });
    }
  });

  return changes;
};

export default customCalibrationOutputsAfterCellsChanged;
